import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const lordBourscheid: NarratorNPC = {
  id: 'lord-bourscheid',
  name: 'Lord Henri of Bourscheid',
  dialog: dialog,
};
